import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ButtonVariant, DropdownOption, DropdownOptionDefault, DropdownOptionGroup, DropdownOptionType, DropdownSelectionType, IconName, PopoverPosition } from '@yupma/ui-kit';
import { FieldOption } from 'server-model';

@Component({
  selector: 'app-dropdown-input',
  templateUrl: './dropdown-input.component.html',
  styleUrl: './dropdown-input.component.scss'
})
export class DropdownInputComponent implements OnInit, OnChanges {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() value: string = '';
  @Input() required: boolean = false;
  @Input() hideOptional: boolean = false;
  @Input() error: boolean = false;
  @Input() disabled: boolean = false;
  @Input() inlineInfo: string = '';
  @Input() errorText: string = 'This field is required.';
  @Input() options: FieldOption[] = [];
  @Input() emptyOption: boolean = true;
  @Input() sortAlphabetically: boolean = false;
  @Input() showLabel: boolean = true;
  @Output() valueChange = new EventEmitter<string>();

  isDropdownOpen: boolean = false;
  iconNames = IconName;
  buttonVariants = ButtonVariant;
  selectedOptionLabel: string = '';

  dropdownOptions: DropdownOptionGroup[] = [];
  filteredDropdownOptions: DropdownOptionGroup[] = [];
  popoverPositions = PopoverPosition;
  dropdownSelectionTypes = DropdownSelectionType;


  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes['value']) {
      this.setSelectedOptions()
    }
    if (!!changes['options']) {
      this.createDropdowns()
      this.setSelectedOptions();
    }
  }

  ngOnInit() {
    this.createDropdowns();
    this.setSelectedOptions();
    // this.filteredDropdownOptions = this.dropdownOptions;
  }

  private createDropdowns() {
    const dropdownOptions = this.options.map(option => {
      return new DropdownOptionDefault(
        DropdownOptionType.DEFAULT,
        option.label,
        option.value,
      );
    });
    if (this.sortAlphabetically) {
      dropdownOptions.sort((a, b) => a.label.localeCompare(b.label));
    }
    let dropdownGroup
    if (this.emptyOption) {
      const emptyOption = new DropdownOptionDefault(DropdownOptionType.DEFAULT, '', '');
      dropdownGroup = new DropdownOptionGroup('', [emptyOption, ...dropdownOptions]);
    } else {
      dropdownGroup = new DropdownOptionGroup('', [...dropdownOptions]);

    }

    this.dropdownOptions = [dropdownGroup];
    this.filteredDropdownOptions = [dropdownGroup];
  }

  private setSelectedOptions() {
    const selectedValues = this.value ? this.value.split(';').filter(val => val.trim() !== '') : [''];
    const selectedOptionLabels: string[] = [];

    this.filteredDropdownOptions.forEach(group => {
      group.options.forEach(option => {
        let isSelected = false;
        for (const selectedValue of selectedValues) {
          if (option.value === selectedValue) {
            isSelected = true;
            break;
          }
        }
        option.selected = isSelected;
        if (isSelected) {
          selectedOptionLabels.push(option.label);
        }
      });
    });
    this.selectedOptionLabel = selectedOptionLabels.join(', ');
    if (this.value && !this.selectedOptionLabel) {
      this.selectedOptionLabel = this.value;
    }
  }

  toggleDropdown(state: boolean) {
    this.isDropdownOpen = state;
    this.filteredDropdownOptions = this.dropdownOptions;
  }

  selectedOption(selectedOption: DropdownOption) {
    this.dropdownOptions.forEach(group => {
      group.options.forEach(option => {
        option.selected = false;
      });
    });
    selectedOption.selected = !selectedOption.selected;
    this.value = selectedOption.value;
    this.updateSelectedOptionLabel();
  }

  private updateSelectedOptionLabel(): void {
    const selectedOptions: DropdownOption[] = [];
    this.dropdownOptions.forEach(group => {
      group.options.forEach(option => {
        if (option.selected === true) {
          selectedOptions.push(option);
        }
      });
    });
    this.selectedOptionLabel = selectedOptions.map(item => item.label).join(', ');
    const selectedOptionValues = selectedOptions.map(item => item.value).join(';');
    if (this.value && !this.selectedOptionLabel) {
      this.selectedOptionLabel = this.value;
    }
    this.valueChange.emit(selectedOptionValues)
  }

  search(query: string) {
    const lowerQuery = query.toLowerCase();

    // Filter the options based on the search query
    this.filteredDropdownOptions = this.dropdownOptions.map(group => {
      const filteredOptions = group.options.filter(option => {
        return option.label.toLowerCase().includes(lowerQuery);
      });

      return new DropdownOptionGroup(group.text, filteredOptions);
    }).filter(group => group.options.length > 0);
  }

}
